import { BillDetails } from "../model/bill/types/BillDetails";

export function getInitialRows() {
  return Array.from({ length: 40 }, (_, i) => ({
    qty: "",
    code: "",
    description: "",
    unitPrice: "",
    amount: "",
    index: i,
  })) as BillDetails[];
}
